<template>
  <section class="result" :class="{ 'result--clickable': isClickable }">
    <p class="result__team">
      <span class="result__team__name">{{ homeTeam.name || homeTeam.abbreviation }}</span>
      <span v-if="homeTeam.jerseyUrl" class="result__team__jersey" :style="{ 'backgroundImage': `url(${homeTeam.jerseyUrl}`}" />
    </p>
    <p class="result__score">
      {{ score.join(" - ") }}
    </p>
    <p class="result__team">
      <span v-if="awayTeam.jerseyUrl" class="result__team__jersey" :style="{ 'backgroundImage': `url(${awayTeam.jerseyUrl}`}" />
      <span class="result__team__name">{{ awayTeam.name || awayTeam.abbreviation }}</span>
    </p>
  </section>
</template>

<script setup>
defineProps({
  homeTeam: {
    type: Object,
    required: true,
  },
  awayTeam: {
    type: Object,
    required: true,
  },
  score: {
    type: Array,
    default: undefined,
  },
  isClickable: {
    type: Boolean,
    default: false,
  },
});
</script>

<style lang="scss" scoped>
.result {
  display: flex;
  width: 100%;
  // En parent flex (accordéon), remplit l'espace dispo sans pousser le chevron
  // hors champ -> largeur constante d'une ligne à l'autre, scores alignés.
  // En parent non-flex (titre de modale), width:100% prend le relais.
  flex: 1 1 0%;
  min-width: 0;
  align-items: center;
  justify-content: center;

  &--clickable {
    cursor: pointer;

    .result__score {
      transition: transform .3s ease-out;
      &:hover {
        transform: scale(1.2);
      }
    }
  }

  &__team {
    display: flex;
    align-items: center;
    flex: 1;
    width: 40%;
    margin: 0 6px;
    white-space: nowrap;
    overflow: hidden;
    font-size: 15px;

    &:first-child {
      justify-content: center;
    }

    &__name {
      flex-grow: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: center;
    }

    &__jersey {
      flex-shrink: 0;
      width: 26px;
      height: 26px;
      background-size: cover;
      margin: 0 6px;
    }
  }

  &__score {
    min-width: 30px;
    display: flex;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    color: rgb(232, 30, 41);
    background: rgba(232, 30, 41, 0.08);
    margin: 0;
    padding: 2px 5px;
    border-radius: 5px;
    font-weight: bold;
  }
}
</style>